import { useContentShareControls, useLocalVideo, useMeetingManager, useToggleLocalMute, useContentShareState, } from 'amazon-chime-sdk-component-library-react';
import { useEffect } from 'react';
import { useVideoConfig } from '../video-config-provider';
import { useSignalingApi } from '../../signaling-api';
export const SyncProps = () => {
    const { video, audio, camera, microphone, speaker, onSetScreenShare, onLoadScreenShare, onScreenShare } = useVideoConfig();
    const { isVideoEnabled, toggleVideo } = useLocalVideo();
    const { muted, toggleMute } = useToggleLocalMute();
    const { isLocalUserSharing, isLocalShareLoading } = useContentShareState();
    const { onToggleScreenshare } = useSignalingApi();
    const { toggleContentShare } = useContentShareControls();
    const { selectedVideoInputDevice, selectedAudioInputDevice, selectedAudioOutputDevice, selectVideoInputDevice, selectAudioInputDevice, selectAudioOutputDevice, } = useMeetingManager();
    useEffect(() => {
        if (isVideoEnabled !== video) {
            toggleVideo();
        }
    }, [video]);
    useEffect(() => {
        if (muted === audio) {
            toggleMute();
        }
    }, [audio]);
    useEffect(() => {
        return onToggleScreenshare(enabled => {
            void (onScreenShare === null || onScreenShare === void 0 ? void 0 : onScreenShare(enabled));
            if (enabled !== isLocalUserSharing) {
                void toggleContentShare();
            }
        });
    }, [isLocalUserSharing]);
    useEffect(() => {
        onSetScreenShare(isLocalUserSharing);
    }, [isLocalUserSharing]);
    useEffect(() => {
        onLoadScreenShare(isLocalShareLoading);
    }, [isLocalShareLoading]);
    useEffect(() => {
        if (selectedVideoInputDevice !== camera) {
            selectVideoInputDevice(camera).catch(console.log);
        }
    }, [camera, selectedVideoInputDevice]);
    useEffect(() => {
        if (selectedAudioInputDevice !== microphone) {
            selectAudioInputDevice(microphone).catch(console.log);
        }
    }, [microphone, selectedAudioInputDevice]);
    useEffect(() => {
        if (selectedAudioOutputDevice !== speaker) {
            if ('setSinkId' in HTMLMediaElement.prototype) {
                selectAudioOutputDevice(speaker).catch(console.log);
            }
            else {
                console.log('setSinkId is not supported skipping speaker selection');
            }
        }
    }, [speaker, selectedAudioOutputDevice]);
    return null;
};
//# sourceMappingURL=sync-props.js.map